import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { analytics, EVENTS } from "../analytics";

const Navbar: React.FC = () => {
  // const defaultServiceId = serviceData.map(x => x.id)[0];
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const hashPath = location.hash.replace("#", ""); // "/ko/..."
  const parts = hashPath.split("/").filter(Boolean); // ["ko", "program", ...]
  const lang = parts[0] || "ko";

  const toggleLanguage = () => {
    const nextLang = lang === "ko" ? "en" : "ko";
    i18n.changeLanguage(nextLang);

    parts[0] = nextLang;
    const newHash = "#" + parts.join("/");
    analytics.track(EVENTS.LANGUAGE_SWITCH, { lang: nextLang });
    navigate(newHash);
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">
      <div className="w-full px-4 md:max-w-6xl md:mx-auto flex justify-between items-center h-20">
        <div className="text-2xl font-bold text-main">
          <Link
            to="/"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              analytics.track(EVENTS.CLICK_NAVBAR_HOME);
            }}
            className="inline-flex items-center"
          >
            <img
              src="/beme_transparent.png"
              alt="BeMe Logo"
              className="h-24 w-auto block"
            />
          </Link>
        </div>

        <div className="flex items-center space-x-8">
          <Link
            to={`/service`}
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              analytics.track(EVENTS.CLICK_NAVBAR_SERVICE);
            }}
            className="text-main font-medium hover:text-accent transition-colors"
          >
            Service
          </Link>
          {/*
            <Link
              to="/program/cv"
              className="text-main font-medium hover:text-accent transition-colors"
            >
              Program
            </Link> */}
          <Link
            to="/resources"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="text-main font-medium hover:text-accent transition-colors"
          >
            Resources
          </Link>
          <Link
            to="/about/results"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              analytics.track(EVENTS.CLICK_NAVBAR_ABOUT);
            }}
            className="text-main font-medium hover:text-accent transition-colors"
          >
            About
          </Link>
          <Link to="/faq"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
              analytics.track(EVENTS.CLICK_NAVBAR_FAQ);
            }}
            className="hidden md:block text-main font-medium hover:text-accent transition-colors">
            FAQ
          </Link>

          <nav className="hidden md:block">
            <button onClick={toggleLanguage}>
              {i18n.language === "ko" ? "EN" : "KO"}
            </button>
          </nav>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
